import { render, staticRenderFns } from "./DashboardSideMenu.compoment.vue?vue&type=template&id=4cc3e692&scoped=true"
import script from "./DashboardSideMenu.compoment.vue?vue&type=script&lang=js"
export * from "./DashboardSideMenu.compoment.vue?vue&type=script&lang=js"
import style0 from "./DashboardSideMenu.compoment.vue?vue&type=style&index=0&id=4cc3e692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc3e692",
  null
  
)

export default component.exports